<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link>
            &rsaquo;
            <router-link
              :to="{
                name: 'AtencionForm',
                state: { idAtencion: datoAtencion.idAtencion }
              }"
            >
              Atención {{ p_numeroAtencion }}
            </router-link>
            &rsaquo;
            <router-link :to="{
                           name: 'Atencion_Interconsulta',
                           state: {
                                   idAtencion:     datoAtencion.idAtencion,
                                   estadoAtencion: p_estadoAtencion,
                                   numero:         p_numeroAtencion,
                           }
                         }">
              Interconsultas
            </router-link>
            &rsaquo; {{ datoInterconsulta.especialidad }}
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <hr>

    <!-- Bloque: Datos de la Atención -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Datos de la Atención</b>
      <button class="btn btn-link p-0 text-decoration-none" @click="mostrarBloque = !mostrarBloque">
        <span class="material-symbols-outlined align-middle">
          {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
        </span>
        {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
      </button>
    </div>

    <div class="form-card mb-3">
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Paciente</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombrePaciente" disabled>
          </div>
          <div class="col-1"><label class="col-form-label">Cédula</label></div>
          <div class="col-2">
            <input type="text" class="form-control" v-model="datoAtencion.documentoPaciente" disabled>
          </div>
          <div class="col-1"><label class="col-form-label">Tipo</label></div>
          <div class="col-2">
            <select class="form-select" v-model="datoAtencion.tipo" disabled>
              <option value="I">Inicial</option>
              <option value="S">Subsecuente</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Médico</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreMedico" disabled>
          </div>
          <div class="col-1"><label class="col-form-label">Especial.</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreEspecialidad" disabled>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-1"><label class="col-form-label">Motivo</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.motivo"
                      style="text-transform:uppercase" disabled></textarea>
          </div>
          <div class="col-1"><label class="col-form-label">Obs.</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.observacion"
                      style="text-transform:uppercase" disabled></textarea>
          </div>
        </div>
      </div>

      <!-- Sección colapsable -->
      <div v-if="mostrarBloque" class="mb-3">
        <hr class="my-2" />
        <div class="row">
          <div class="col-2">
            <label class="form-label">Id. Atención</label>
            <input type="text" class="form-control" :value="datoAtencion.idAtencion" disabled>
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Reg.</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaReg)" disabled>
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Act.</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaAct)" disabled>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <!-- Bloque: Datos de la Interconsulta -->
    <b>Datos de la Interconsulta</b>
    <div class="form-card mt-2 mb-3">
      <div class="mb-3" v-if="datoInterconsulta.idInterconsulta">
        <div class="row">
          <div class="col-2"><label class="col-form-label">Id. Interconsulta</label></div>
          <div class="col-10">
            <input type="text" class="form-control" :value="datoInterconsulta.idInterconsulta" disabled>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Especialidad</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoInterconsulta.especialidad" disabled>
          </div>
          <div class="col-1"><label class="col-form-label">Médico</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoInterconsulta.medico" disabled>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-1"><label class="col-form-label">Motivo</label></div>
          <div class="col-11">
            <textarea class="form-control" v-model="datoInterconsulta.motivo" disabled></textarea>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-1"><label class="col-form-label">Cuadro</label></div>
          <div class="col-11">
            <textarea class="form-control" v-model="datoInterconsulta.cuadro" disabled></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Botones de formularios -->
    <div class="d-flex justify-content-center gap-4 mb-4">
      <div>
        <Modal v-model:modelValue="showModalSolicitud" title="Formulario 007 - Solicitud">
          <DocVerFirmarGuardar :idReporte="3" :idDocumento="datoInterconsulta.idInterconsulta" />
        </Modal>
        <button type="button" class="btn btn-outline-success d-flex align-items-center gap-2"
          @click="showModalSolicitud = true" title="Formulario 007 - Solicitud">
          <span class="material-symbols-outlined" style="font-size:24px">quick_reference_all</span>
          Formulario 007 — Solicitud
        </button>
      </div>

      <div>
        <Modal v-model:modelValue="showModalInforme" title="Formulario 007 - Informe">
          <DocVerFirmarGuardar :idReporte="4" :idDocumento="datoInterconsulta.idInterconsulta" />
        </Modal>
        <button type="button"
          class="btn d-flex align-items-center gap-2"
          :class="datoInterconsulta.estadoInter === 'FINALIZADA' ? 'btn-outline-success' : 'btn-outline-secondary'"
          @click="showModalInforme = true"
          :disabled="datoInterconsulta.estadoInter !== 'FINALIZADA'"
          title="Formulario 007 - Informe">
          <span class="material-symbols-outlined" style="font-size:24px">quick_reference_all</span>
          Formulario 007 — Informe
        </button>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout             from '@/components/Layout.vue'
import Footer             from '@/components/Footer.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue'
import dateFormat         from '@/modules/dateFormat.js'
import api                from '@/services/api'

export default {
  components: { Layout, Footer, DocVerFirmarGuardar },
  props: {
    p_numeroAtencion:  { type: String, required: true },
    p_estadoAtencion:  { type: String, required: true },
    p_idInterconsulta: { type: Number, required: true },
  },
  data() {
    return {
      datoAtencion:       {},
      datoInterconsulta:  {},
      mostrarBloque:      false,   // FIX: faltaba en data()
      showModalHelp:      false,
      showModalSolicitud: false,
      showModalInforme:   false,
    }
  },
  mounted() {
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    getData() {
      api.get(`/vwinterconsultas/${this.p_idInterconsulta}`)
        .then(response => {
          this.datoInterconsulta = response.data
          if (response.data.idAtencion) {
            api.get(`/vwatencions/${response.data.idAtencion}`)
              .then(resp => { this.datoAtencion = resp.data })
          }
        })
        .catch(err => console.error('Error al obtener interconsulta:', err))
    },
  },
}
</script>

<style scoped>
.btn-help {
  background: none; border: none; padding: 0; cursor: pointer; color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px; transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined { color: #0a58ca; }
</style>